import React from 'react';
import { ReviewResponse } from '../../../../../types/api/review';
import { formatDateTime } from '../../../../../helpers/dates';
import UserCard from '../../components/UserCard';
import { Stack, Text } from '@primer/react'

interface UserReviewCardProps {
    review: ReviewResponse;
}

export const UserReviewCard: React.FC<UserReviewCardProps> = ({ review }) => {
    const mainImage = review.ad?.media?.[0]?.preview;

    return (
        <div>
            <Stack justify="space-between" direction="horizontal" className='mb-[10px]'>
                <UserCard
                    author={review.author}
                    avatarSize={40}
                    isShowStatus={false}
                    rating={review.rating}
                    nameFontSize={16}
                    ratingFontSize={14}
                    ratingHeight={14}
                />

                <Text
                    fontSize={14}
                    color="fg.muted"
                    mb={2}
                    display="block"
                >
                    {formatDateTime(review.createdAt)}
                </Text>
            </Stack>

            <Stack direction="horizontal" align="center" className='ml-[52px]' gap='none'>
                {/* Изображение */}
                <div
                    className='bg-header border border-border rounded-md w-[24px] h-[24px] flex-shrink-0'
                    style={{
                        backgroundImage: `url("${mainImage && mainImage.trim() ? mainImage : '/icons/avatar.png'}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                />
                <div>
                    <Stack direction="horizontal" align="center" className='ml-[6px]'>
                        <Text
                            fontSize={14}
                            fontWeight="semibold"
                            color="fg.default"
                            lineHeight="medium">
                            {review.ad.title}
                        </Text>

                    </Stack>
                </div>

            </Stack>

            <Text
                fontSize={16}
                fontWeight="regular"
                color="fg.default"
                className='ml-[52px] mt-1 block'
            >
                {review.text}
            </Text>
            <div className='border-b border-separator ml-[52px] pt-5 mb-5'></div>

        </div>
    );
};